import { render, staticRenderFns } from "./ViewI18n.vue?vue&type=template&id=4b3a665c&scoped=true&"
import script from "./ViewI18n.vue?vue&type=script&lang=js&"
export * from "./ViewI18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3a665c",
  null
  
)

export default component.exports